const isWsAssistKillswitchEnabled = () => !!Sephora.configurationSettings?.genAIChatBotWsAssist?.isEnabled;

const selectWsAssistEnabled = () => isWsAssistKillswitchEnabled();

export {
    selectWsAssistEnabled, isWsAssistKillswitchEnabled
};
